// =============================================================================
// ModifierMath — pure math port of Services/ModifierMath.cs
// Formula: Math.ceil(base * mult + add), floored at 0.
// Canonical rounding for ALL numeric modifiers (build cost, toll, energy, pollution).
// =============================================================================

export interface ModifierMathLog {
  sourceTag: string;
  baseVal: number;
  mult: number;
  add: number;
  result: number;
}

/**
 * Apply a multiplicative-then-additive modifier, ceil the result, floor at 0.
 * Returns the final integer value.
 *
 * @param baseVal  - the base integer value before modification
 * @param mult     - multiplicative factor (1.0 = no change)
 * @param add      - additive adjustment after multiplication
 * @param sourceTag - attribution label for logging (passed back in log entry)
 * @returns        { result, log } — result is the final int ≥ 0
 */
export function applyModifier(
  baseVal: number,
  mult: number,
  add: number,
  sourceTag: string,
): { result: number; log: ModifierMathLog } {
  const raw = baseVal * mult + add;
  const ceiled = Math.ceil(raw);
  const result = Math.max(0, ceiled);
  const log: ModifierMathLog = { sourceTag, baseVal, mult, add, result };
  return { result, log };
}
